<!-- 关于我们 -->
<template>
  <div class="index">
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <!-- <div class="image-wrapper_1 flex-row">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge8bb2a5d139016f795f6ddb9c33eef5db8db2f1a74a149dec3c1da50e2702da3"
      />
    </div> -->
    <div class="block_red flex-col"></div>
    <div class="block_9">
      <div class="main">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge73d4969448c0c099997a3e563ebf3a5d02171a1afdf68465ddec07eff136eba"
        />
        <img
          class="thumbnail_1"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb59cce0e73798de2431f26b74202ba9b19d58adc145d502515db964d7c84cd77"
        />
        <span class="text_13 buts" @click="back()">返回首页</span>
        <img
          class="thumbnail_2"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
        />
        <span class="text_14">关于我们</span>
      </div>
    </div>
    <div class="containt">
      <!-- <h1 class="text_15 flex-row justify-between">如果您想通过留学完成您的梦想，我们是您通往梦想的桥梁</h1>      -->
      <div class="group_4 flex-row justify-between">
        <span class="paragraph_1"
          >我们本着客观而又中立的立场，从校方直接采集学校信息，并通过实地考察形式来进一步校验校方提供的信息是否精准。该网站拥有全日本共853所语言学校的详细信息。该网站以帮助学生更好地了解并精准查找日本语学校信息为目的，学生可以直接与意向日本语学校的老师取得联系。使学生可以更客观和深刻的了解自己想去的学校。（部分学校信息还处于校验阶段，敬请谅解。）
          <p>
            学生可通过地区，城市，车站名进行精准筛选查找相应区域内的所有日本语学校信息，也可以通过，学校特色，热门话题等关键词查找符合自己要求的日本语学校。
          </p>
          <p>
            每所日本语学校的主页，我们以图文形式，将日本语学校的申请条件，特色，国籍比率，教育信息，考学信息展现给学生，使学生更直观的了解每所日本语学校。
          </p>
          <p>
            此外，网站还定期更新最新的日本留学动态，衣食住行相关的留学生活信息，如；餐饮店，住房及学生宿舍，勤工俭学和就职信息，方便用户提前做好留学规划。
          </p>
          <br />
          声明：本网站的信息全部为校方提供的第一手信息，未经加工或提供不切实际的信息。</span
        >
        <div class="group_5 flex-col" style="position: relative;">
          <img
            style="position: absolute;top: 30px;right: 30px; width: 338px;
    height: 320px;"
            referrerpolicy="no-referrer"
            src="https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/aae4e733e0ce4392b1692cbb3ffc3660_mergeImage.png"
          />
        </div>
      </div>
      <div class="group_6 flex-row">
        <div class="image-text_1 flex-row justify-between">
          <span class="text-group_1 buts" @click="gotoweixin">联系我们</span>
          <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng97c249608266b644f91e15e013521a8db107e30a67a78ac90c7689ac7d563fc7"
          />
        </div>
      </div>


      <!-- <div class="groupssssss_20 flex-col"></div> -->
    </div>

    <div class="group_7">
      <div class="main flex-row">
        <div class="image-text_2 flex-col justify-between">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngcbe634df85b453d6d122c669368f553df05639a61537975c3713f9d08fa90535"
          />
          <span class="text-group_2">国内留学规划与出过培训的专业咨询机构</span>
        </div>
        <div class="group_8 flex-col"></div>
        <div class="image-text_3 flex-col justify-between">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb14b09b9fa57649d88dc79e9e9dfe92d65abb56a96ba3b2c586496839cd1eeae"
          />
          <span class="text-group_2">从咨询到入学的一站式服务</span>
        </div>
        <div class="group_9 flex-col"></div>
        <div class="image-text_4 flex-col justify-between">
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnga2973a9e56ba69318a37f56727eaf9189b596bf6b6233e4295a4c23a562fe993"
          />
          <span class="text-group_2">日本留学促进交流协会名下的专业机构</span>
        </div>
        <div class="group_10 flex-col"></div>
        <div class="image-text_5 flex-col justify-between">
          <img
            class="image_5"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng1f1b74861b5c5c60e7c68001b1c0688a644fe55602674f5d6f56aa70c43f3f74"
          />
          <span class="text-group_2">在日本有办事处，日本现地服务完备</span>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="image-wrapper_2 flex-col">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7eb9876181493c73450e3a508ae07988f5b19ee98ae37cce3dc74eda6e3f707b"
        />
      </div>
      <div class="group_11 flex-row">
        <div class="group_12 flex-col justify-between">
          <div class="text-group_6 flex-col justify-between">
            <span class="text_16">联系我们</span>
            <span class="text_17">お問合せ</span>
          </div>
          <div class="section_1 flex-col"></div>
        </div>
        <div class="group_13 flex-col justify-between">
          <span class="text_18">姓名</span>
          <div class="text-wrapper_7 flex-col">
            <!-- <span class="text_19">请输入姓名</span> -->
            <el-input
              v-model="from.tb_username"
              placeholder="请输入姓名"
            ></el-input>
          </div>
        </div>
        <div class="group_14 flex-col justify-between">
          <span class="text_20">手机号</span>
          <div class="text-wrapper_8 flex-col">
            <!-- <span class="text_21">请输入手机号</span> -->
            <el-input
              v-model="from.tb_phono"
              placeholder="请输入手机号"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="group_15 flex-row">
        <div class="box_8 flex-col">
          <div class="group_16 flex-row justify-between">
            <div class="text-group_7 flex-col justify-between">
              <span class="text_22">联系人：</span>
              <span class="text_23">{{ "暂无数据" }}</span>
            </div>
            <div class="text-group_8 flex-col justify-between">
              <span class="text_24">电话：</span>
              <span class="text_25">{{ gaunyuList.tb_weixin }}</span>
            </div>
          </div>
          <div class="text-group_9 flex-col justify-between">
            <span class="text_26">邮箱：</span>
            <span class="text_27">{{ "暂无数据" }}</span>
          </div>
          <span class="text_28">地址：</span>
          <span class="text_29">{{ gaunyuList.tb_contact }}</span>
        </div>
        <div class="box_9 flex-col justify-between">
          <span class="text_30">资询内容</span>
          <div class="text-wrapper_9 flex-col">
            <!-- <span class="text_31">请输入您想了解的内容</span> -->
            <el-input
              v-model="from.tb_context"
              placeholder="请输入您想了解的内容"
              type="textarea"
              :rows="6"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="group_17 flex-row justify-between">
        <div
          class="text-wrapper_10 flex-col"
          :plain="true"
          @click="submitForm()"
        >
          <span class="text_33 buts">提交</span>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="100%"
      :before-close="handleClose"
    >
      <video :src="videoSrc" controls="controls" autoplay>
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog> -->
    <my_article></my_article>
    <div class="group_54 flex-col">
      <my-footer class="navbarone"></my-footer>
    </div>
  </div>
</template>

<script>
import navbar from "../components/navbar/navbar.vue";
import footer from "../components/footer/footer.vue";
import article from "../components/article/article.vue";
import { GetTijiao } from "../api/tijiao";
import { GetGuanyu } from "../api/guanyu";
export default {
  components: {
    "my-navbar": navbar,
    "my-footer": footer,
    my_article: article
  },
  data() {
    return {
      gaunyuList: [],
      tijiaoList: [],
      from: { tb_username: "", tb_phono: "", tb_context: "" }
    };
  },
  created() {
    this.getguanyu();
    document.documentElement.scrollTop = 0;
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  methods: {
    //返回首页
    back() {
      this.$router.push("page/index");
    },
    handleClose(done) {
      done();
    },

    //关于我们提交
    submitForm: function() {
      // console.log(this.from.value);
      if (
        this.from.tb_username == "" ||
        this.from.tb_phono == "" ||
        this.from.tb_context == ""
      ) {
        this.$message.error("请填写正确的信息！！！");
        return;
      }
      GetTijiao(this.from).then(response => {
        if (response.code === 20000) {
          this.from.tb_username = "";
          this.from.tb_phono = "";
          this.from.tb_context = "";
          this.$message({
            message: "提交成功！！！",
            type: "success"
          });
        }
      });
    },
    //关于我们页面信息
    getguanyu() {
      GetGuanyu().then(response => {
        this.gaunyuList = response.data;
        console.log("关于我们页面信息", this.gaunyuList.tb_customer_link);
      });
    },
    gotoweixin() {
      window.open(this.gaunyuList.tb_customer_link);
    },
    //提交
    tijiao() {
      // console.log(this.from.length);
      if (
        this.from.tb_username != "" ||
        this.from.tb_phono != "" ||
        this.from.tb_context != ""
      ) {
        this.submitForm();
        console.log("xxxxxxxxxxx");
      } else {
        this.$message.error("请填写正确的信息！！！");
      }
    }
  }
};
</script>
<style src="../../static/css/regard.css" scoped />
<style scoped>
.article {
  display: flex;
  justify-content: center;
}

.link {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/regard.vue